const ACTIVE_CHANGE = 1;

export default {
    ACTIVE_CHANGE
}